import Dosa from '../images/dosa.jpg'
import Chola from '../images/chhola.jpg'
import Idli from '../images/idli.jpg'
import MasalaDosa from '../images/masala.jpg'
import Paneer from '../images/paneer.jpg'
import Gujrati from '../images/gujrati.jpeg'

export const MenuList = [
    {
        name: 'Dosa',
        description: 'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Laborum, iure.',
        image: Dosa,
        Price: 200
    },
    {
        name: 'Chola',
        description: 'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Laborum, iure.',
        image: Chola,
        Price: 250
    },
    {
        name: 'Idli',
        description: 'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Laborum, iure.',
        image: Idli,
        Price: 100
    },
    {
        name: 'MasalaDosa',
        description: 'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Laborum, iure.',
        image: MasalaDosa,
        Price: 300
    },
    {
        name: 'Paneer',
        description: 'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Laborum, iure.',
        image: Paneer,
        Price: 500
    },
    {
        name: 'Gujrati',
        description: 'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Laborum, iure.',
        image: Gujrati,
        Price: 650
    }
]